import { createContext, useContext, useEffect, useState } from "react";
import { api, errorText } from "@/lib/api";
import { readUser, writeUser } from "@/lib/cache";
import { applyPrefs } from "@/lib/prefs";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(() => { const u = readUser(); applyPrefs(u?.prefs); return u; });
  const setUser = (u) => { applyPrefs(u?.prefs); writeUser(u); setUserState(u); };

  useEffect(() => {
    // Returning from Google sign-in: AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => api.post("/auth/refresh").then((r) => setUser(r.data)).catch(() => setUser(false)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return null;
    } catch (e) {
      return errorText(e);
    }
  };

  const register = async (name, email, password) => {
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      setUser(data);
      return null;
    } catch (e) {
      return errorText(e);
    }
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, register, logout, setSession: setUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
